import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../Config/config";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Switch,
  FormControlLabel,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Tooltip,
  Typography,
  Autocomplete,
} from "@mui/material";
import { Edit, Delete, ContentCopy } from "@mui/icons-material";
import {
  FormControl,

  Checkbox,

} from "@mui/material";

export default function Coupons() {
  const [coupons, setCoupons] = useState([]);
  const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [form, setForm] = useState({
    code: "",
    startDate: new Date(),
    endDate: new Date(),
    usageLimit: 1,
    active: true,
    allowedUsers: [],
    discountPercentage: 0,
  });
  const [users, setUsers] = useState([]);

  useEffect(() => {
    fetchCoupons();
    axios.get(`${config.API_BASE_URL}/get-all-users`)
      .then(res => setUsers(res.data))
      .catch(err => console.error(err));
  }, []);

  const fetchCoupons = () => {
    axios.get(`${config.API_BASE_URL}/get-all-coupons`)
      .then(res => setCoupons(res.data))
      .catch(err => console.error(err));
  };

  const handleOpenCreate = () => {
    setIsEdit(false);
    setForm({
      code: "",
      startDate: new Date(),
      endDate: new Date(),
      usageLimit: 1,
      active: true,
      allowedUsers: [],
      discountPercentage: 0,
    });
    setOpen(true);
  };

  const handleEdit = (c) => {
    setIsEdit(true);
    setForm({
      code: c.code,
      startDate: new Date(c.startDate),
      endDate: new Date(c.endDate),
      usageLimit: c.usageLimit,
      active: c.active,
      allowedUsers: c.allowedUsers || [],
      discountPercentage: c.discountPercentage || 0,
    });
    setOpen(true);
  };

  const handleDelete = (code) => {
    axios.delete(`${config.API_BASE_URL}/delete-coupon/${code}`)
      .then(() => fetchCoupons())
      .catch(err => console.error(err));
  };

  const handleSave = () => {
    const payload = {
      code: form.code,
      startDate: form.startDate.toISOString(),
      endDate: form.endDate.toISOString(),
      usageLimit: form.usageLimit,
      discountPercentage: form.discountPercentage,
      active: form.active,
      allowedUsers: form.allowedUsers,
    };
    const req = isEdit
      ? axios.put(`${config.API_BASE_URL}/update-coupon`, payload)
      : axios.post(`${config.API_BASE_URL}/create-coupon`, payload);
    req.then(() => {
      setOpen(false);
      fetchCoupons();
    }).catch(err => console.error(err));
  };

  return (
    <div className="p-4">
      <button className="bg-primary text-white p-2 rounded mx-2" onClick={handleOpenCreate}>
        Generate Coupon
      </button>
      
      {/* Desktop/Tablet Table View - Original Design */}
      <div className="hidden sm:block">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Code</TableCell>
              <TableCell>Start</TableCell>
              <TableCell>End</TableCell>
              <TableCell>Limit</TableCell>
              <TableCell>Discount %</TableCell>
              <TableCell>Used</TableCell>
              <TableCell>Active</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {coupons.map(c => (
              <TableRow key={c.code}>
                <TableCell>
                  {c.code}
                  <Tooltip title="Copy code" arrow>
                    <IconButton
                      size="small"
                      onClick={() => navigator.clipboard.writeText(c.code)}
                    >
                      <ContentCopy fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </TableCell>
                <TableCell>{new Date(c.startDate).toLocaleDateString()}</TableCell>
                <TableCell>{new Date(c.endDate).toLocaleDateString()}</TableCell>
                <TableCell>{c.usageLimit}</TableCell>
                <TableCell>{c.discountPercentage}%</TableCell>
                <TableCell>{c.usageCount}</TableCell>
                <TableCell>
                  <Typography
                    variant="body2"
                    style={{ color: c.active ? "green" : "red", fontWeight: 600 }}
                  >
                    {c.active ? "Yes" : "No"}
                  </Typography>
                </TableCell>
                <TableCell>
                  <IconButton onClick={() => handleEdit(c)}><Edit /></IconButton>
                  <IconButton onClick={() => handleDelete(c.code)}><Delete /></IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      {/* Mobile Card View - Only for very small screens */}
      <div className="sm:hidden space-y-3 mt-4">
        {coupons.map(c => (
          <div key={c.code} className="bg-white rounded-lg shadow p-4 border border-gray-200">
            <div className="flex justify-between items-start mb-3">
              <div className="flex items-center gap-2">
                <span className=" text-sm">{c.code}</span>
                <Tooltip title="Copy code" arrow>
                  <IconButton
                    size="small"
                    onClick={() => navigator.clipboard.writeText(c.code)}
                  >
                    <ContentCopy sx={{ fontSize: '1rem' }} />
                  </IconButton>
                </Tooltip>
              </div>
              <Typography
                variant="body2"
                sx={{ 
                  color: c.active ? "green" : "red", 
                  fontWeight: 600,
                  fontSize: '0.75rem'
                }}
              >
                {c.active ? "Active" : "Inactive"}
              </Typography>
            </div>
            
            <div className="grid grid-cols-2 gap-2 text-sm mb-3">
              <div>
                <span className="text-gray-600">Start:</span>
                <div className="font-medium">{new Date(c.startDate).toLocaleDateString()}</div>
              </div>
              <div>
                <span className="text-gray-600">End:</span>
                <div className="font-medium">{new Date(c.endDate).toLocaleDateString()}</div>
              </div>
              <div>
                <span className="text-gray-600">Discount:</span>
                <div className="font-medium">{c.discountPercentage}%</div>
              </div>
              <div>
                <span className="text-gray-600">Used:</span>
                <div className="font-medium">{c.usageCount} / {c.usageLimit}</div>
              </div>
            </div>
            
            <div className="flex gap-2 pt-2 border-t border-gray-200">
              <button
                onClick={() => handleEdit(c)}
                className="flex-1 text-white py-2 px-3 rounded text-sm flex items-center justify-center gap-1"
                style={{ backgroundColor: '#333399' }}
              >
                <Edit sx={{ fontSize: '1rem' }} />
                Edit
              </button>
              <button
                onClick={() => handleDelete(c.code)}
                className="flex-1 text-white py-2 px-3 rounded text-sm flex items-center justify-center gap-1"
                style={{ backgroundColor: '#b91c1c' }}
              >
                <Delete sx={{ fontSize: '1rem' }} />
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>{isEdit ? "Edit Coupon" : "Generate Coupon"}</DialogTitle>
        <DialogContent>
          <div className="space-y-4">
            <FormControl fullWidth>
              <DatePicker
                selected={form.startDate}
                onChange={(d) => setForm(f => ({ ...f, startDate: d }))}
                customInput={
                  <TextField
                    label="Start Date"
                    variant="outlined"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                  />
                }
              />
            </FormControl>
            <FormControl fullWidth>
              <DatePicker
                selected={form.endDate}
                onChange={(d) => setForm(f => ({ ...f, endDate: d }))}
                customInput={
                  <TextField
                    label="End Date"
                    variant="outlined"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                  />
                }
              />
            </FormControl>
            <TextField
              label="Usage Limit"
              type="number"
              fullWidth
              value={form.usageLimit}
              onChange={(e) => setForm(f => ({ ...f, usageLimit: +e.target.value }))}
            />
            <TextField
              label="Discount %"
              type="number"
              fullWidth
              value={form.discountPercentage}
              onChange={(e) =>
                setForm(f => ({ ...f, discountPercentage: +e.target.value }))
              }
            />
            <FormControlLabel
              control={
                <Switch
                  checked={form.active}
                  onChange={(e) => setForm(f => ({ ...f, active: e.target.checked }))}
                />
              }
              label="Active"
            />
            <Autocomplete
              multiple
              options={users}
              getOptionLabel={(u) => `${u.username} (${u.email})`}
              value={users.filter(u => form.allowedUsers.includes(u.userId || u.id))}
              onChange={(e, value) =>
                setForm(f => ({
                  ...f,
                  allowedUsers: value.map(u => u.userId || u.id),
                }))
              }
              filterSelectedOptions
              renderOption={(props, u, { selected }) => (
                <li {...props}>
                  <Checkbox
                    checked={selected}
                    style={{ marginRight: 8 }}
                  />
                  {`${u.username} (${u.email})`}
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Allowed Users"
                  placeholder="Search users"
                  variant="outlined"
                />
              )}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <button className="bg-primary text-white p-2 rounded mx-2" onClick={() => setOpen(false)}>Cancel</button>
          <button className="bg-primary text-white p-2 rounded mx-2" onClick={handleSave}>
            {isEdit ? "Update" : "Create"}
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
}